import React from 'react';
import Standards from "../Standards";

import {Modal} from "./style";

export default function PopupStandards({standards, isOpen, onClose}) {
  return <Modal isOpen={isOpen} onRequestClose={onClose}>
    <Standards standards={standards} />
  </Modal>
}